import { post, get,postJson,deleteApi,put,postBlob } from '../axios'

const RESOURCE_BASE_PATH = '/intelligent-marketing/api/'

export const getIntelligentList = p => get(`${RESOURCE_BASE_PATH}`, p);

export const updateIntelligent = p => postJson(`${RESOURCE_BASE_PATH}`, p);

// 查询所有模板接口
export const getAllTemplateList = p => get(`${RESOURCE_BASE_PATH}getAllTemplateList`, p);

// 删除自定义模板接口
export const delCustomizeT = p => get(`${RESOURCE_BASE_PATH}delCustomizeTemplate/${p}`)

// 创建智能营销活动
export const addSmartMarketing = p => postJson(`${RESOURCE_BASE_PATH}saveActivity`, p)

// 删除智能营销活动
export const delSmartMarketing = p => deleteApi(`${RESOURCE_BASE_PATH}${p}`);

// 复制智能营销活动 /intelligent-marketing/api/copyActivity/{id}
export const copySmartMarketing = p => postJson(`${RESOURCE_BASE_PATH}copyActivity/${p}`);

// 终止智能营销活动 /intelligent-marketing/api/stopActivity/{id}
export const stopSmartMarketing = p => put(`${RESOURCE_BASE_PATH}stopActivity/${p}`);

// 另存模板
export const saveTemplate = p => postJson(`${RESOURCE_BASE_PATH}saveTemplate`, p);

// 分页查询智能营销短信记录
export const getSmsRecordPage = p => get(`${RESOURCE_BASE_PATH}sms-record/page`, p);

// 取消发送
export const cancelSendSms = p => postJson(`${RESOURCE_BASE_PATH}sms-record/cancel`, p);

// 查询智能营销短信记录下拉框
export const getSmsRecordDown = p => get(`${RESOURCE_BASE_PATH}sms-record/list/${p}`);

// 获取活动节点最小等待时间
export const getMinWaitTime = p => get(`${RESOURCE_BASE_PATH}getMinWaitTime`, p);

// 短信记录
export const getRecordList = p => get(`/sms/marketing/effect/analyze/official/select/export?${p}`);

// 导出处理
// export const intelligentExport = p => get(`/sms/marketing/effect/analyze/official/select/export?${p}`);
export const intelligentExport = p => get(`/sms/marketing/effect/analyze/official/select/export`,p);

//一键替换文案
export const replaceContents = p => postJson(`${RESOURCE_BASE_PATH}replaceContent`, p);

//活动置顶
export const topSort = p => get(`${RESOURCE_BASE_PATH}top-sort/top`,p);

//活动置顶个数
export const topSortNum = p => get(`${RESOURCE_BASE_PATH}top-sort`,p);


//启动
export const activityStart = p => post(`${RESOURCE_BASE_PATH}startActivity/${p}`);

//暂停
export const suspendActivity = p => post(`${RESOURCE_BASE_PATH}suspendActivity/${p}`);

//保存配置
export const startActivity = p => postJson(`${RESOURCE_BASE_PATH}/saveSetting`,p);

//获取配置
export const getSetting = p => postJson(`${RESOURCE_BASE_PATH}/getSetting`,p);

//查询活动是否生成批次接口
export const checkMarketingExecuted = p => get(`${RESOURCE_BASE_PATH}/checkMarketingExecuted/${p}`);

//导出画布
export const exportCanvas= p => postBlob(`/intelligent-marketing/api/removeDuplicateNode/export`, p);

// 批量检查及修改触达节点
export const getReachNodeList = p => get(`/intelligent-marketing/api/getReachNodeList`,p);

// 批量检查及修改触达节点
export const autoSetBatchNodeNames = p => get(`/intelligent-marketing/api/autoSetBatchNodeNames`,p);
